// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"735":"86327008","960":"58f13c10"}[chunkId] + ".chunk.js";
};